// extracted by mini-css-extract-plugin
export default {"component":"ToTopButton__component--lc-ujdBz","icon":"ToTopButton__icon--lc-U1txD","visible":"ToTopButton__visible--lc-KeKpV"};